// 事件通信
import mitt from "mitt";
const emitter = mitt()
export default emitter